function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'french-navy': 'rgb(33, 69, 94)','burgundy': 'rgb(128, 0, 32)','khaki': 'rgb(138, 134, 99)','heather-grey': 'rgb(201, 201, 199)','desert-dust': 'rgb(216, 208, 188)','bottle-green': 'rgb(8, 99, 49)','deep-charcoal-grey': 'rgb(66, 62, 60)','grey-melange': 'rgb(181, 180, 179)','navy-blazer': 'rgb(40, 45, 60)','carbon-grey': 'rgb(191, 191, 191)','oyster': 'rgb(217, 201, 173)','pacific': 'rgb(33, 52, 82)','charcoal': 'rgb(83, 87, 89)','jungle': 'rgb(154, 144, 109)','oxford-navy': 'rgb(40, 45, 60)','light-avio-blue': 'rgb(135, 175, 203)','mustard-yellow': 'rgb(218, 171, 91)','leaf-green': 'rgb(187, 193, 120)','navy-blue': 'rgb(30, 59, 85)','bordeuax': 'rgb(92, 1, 32)','green': 'rgb(33, 73, 48)','white-raw': 'rgb(214, 199, 177)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
